import { render, staticRenderFns } from "./OddsConfiguration.vue?vue&type=template&id=767daf30&"
import script from "./OddsConfiguration.vue?vue&type=script&lang=js&"
export * from "./OddsConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports